import {
  apisTrackHotjarEvent,
  blockListOriginPathUser,
  blockListApiRequestPaths,
  blockOriginPathUser,
  HotjarSendApiEvent,
  HotjarSendEventByTypeAndDescription,
  EHotjarEventType
} from '@/models/hotjar-options';

interface IHotjarScriptProps {
  isImpersonated?: boolean;
  isSuperAdmin?: boolean;
}

export const addHotjarScript = async ({
  isImpersonated,
  isSuperAdmin
}: IHotjarScriptProps) => {
  const shouldAddHotjarScript = !isImpersonated && !isSuperAdmin;

  if (!shouldAddHotjarScript) return;

  const script = document.createElement('script');

  const hotjarId = process.env.VUE_APP_HOTJAR_ID;

  script.type = 'text/javascript';
  const scriptCode = `(function(h,o,t,j,a,r){
    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
    h._hjSettings={hjid:${hotjarId},hjsv:6};
    a=o.getElementsByTagName('head')[0];
    r=o.createElement('script');r.async=1;
    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
    a.appendChild(r);
})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;

  script.innerText = scriptCode;

  document.head.appendChild(script);
};

const adjustUrlRequest = (urlOriginal: string): string => {
  let newUrl = decodeURIComponent(urlOriginal);

  const auxUrlParams = newUrl.split('?');
  if (auxUrlParams.length > 1) {
    newUrl = auxUrlParams[0];
  }

  return newUrl;
};

const urlIsBlockedByListOriginPath = (
  pathname: string,
  typeEvent: EHotjarEventType,
  methodRequest: string
): boolean => {
  const searchedBlockedUrl = blockListOriginPathUser.find(
    (blockedUrl: blockOriginPathUser) => {
      return blockedUrl.originPath === pathname;
    }
  );

  return (
    !!searchedBlockedUrl &&
    searchedBlockedUrl.types.includes(typeEvent) &&
    searchedBlockedUrl.methods.includes(methodRequest)
  );
};

export function sendApiEventToHotjar({
  typeEvent,
  methodRequest,
  hostApiRequest,
  pathnameApiRequest
}: HotjarSendApiEvent) {
  const { pathname } = window.location;
  const transformedMethodRequest = methodRequest.toUpperCase();
  const decodedPathnameUser = adjustUrlRequest(pathname);
  const decodedPathnameApi = adjustUrlRequest(pathnameApiRequest);

  if (
    !apisTrackHotjarEvent.includes(hostApiRequest) ||
    urlIsBlockedByListOriginPath(
      decodedPathnameUser,
      typeEvent,
      transformedMethodRequest
    ) ||
    blockListApiRequestPaths.includes(decodedPathnameApi) ||
    (transformedMethodRequest === 'GET' && typeEvent !== 'error')
  ) {
    return;
  }

  const methodsLabelMapper: Record<string, string> = {
    POST: 'form_submit',
    PUT: 'form_update',
    PATCH: 'form_update',
    GET: 'get_info',
    DELETE: 'form_delete'
  };

  if (window.hj) {
    window.hj(
      'event',
      `${typeEvent}_${methodsLabelMapper[transformedMethodRequest] || ''}`
    );
  }
}

export function sendEventHotjarByTypeAndDescription({
  typeEvent,
  description
}: HotjarSendEventByTypeAndDescription) {
  if (window.hj) window.hj('event', `${typeEvent}_${description}`);
}
